import React from "react";
import "../../styles/BackgroundWrapper.css";

export function BackgroundWrapper(props) {
  return (
    <>
      <div className="app">
        <div className="create__contentWrapper">
          <div className="formWrapper">{props.children}</div>
        </div>
      </div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </>
  );
}

export function BackgroundWrapperMobile(props) {
  return (
    <>
      <div className="app">
        <div className="create__contentWrapper--mobile">
          <div className="formWrapper--mobile">{props.children}</div>
        </div>
      </div>
    </>
  );
}